import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

import { _throw } from 'rxjs/observable/throw';
import { catchError } from 'rxjs/operators';

@Injectable()
export class AppService {
  constructor(private http: HttpClient) {}

  base_url = environment.apiUrl;
  api_key = this.getApiKey();

  private formatErrors(error: any) {
    return _throw(error.error);
  }

  private getApiKey() {
    let dataStorage = JSON.parse(localStorage.getItem('user'));
    if (dataStorage) {
      return dataStorage.api_key;
    } else {
      return '';
    }
  }

  get(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    return this.http
      .get(`${this.base_url}${path}?api_key=${this.getApiKey()}`, { params })
      .pipe(catchError(this.formatErrors));
  }

  put(path: string, body: Object = {}): Observable<any> {
    return this.http
      .put(`${this.base_url}${path}?api_key=${this.getApiKey()}`, JSON.stringify(body), {
        headers: { 'Content-Type': 'application/json' },
      })
      .pipe(catchError(this.formatErrors));
  }

  patch(path: string, body: Object = {}): Observable<any> {
    return this.http
      .patch(`${this.base_url}${path}?api_key=${this.getApiKey()}`, JSON.stringify(body), {
        headers: { 'Content-Type': 'application/json' },
      })
      .pipe(catchError(this.formatErrors));
  }

  post(path: string, body: Object = {}): Observable<any> {
    return this.http
      .post(`${this.base_url}${path}?api_key=${this.getApiKey()}`, JSON.stringify(body), {
        headers: { 'Content-Type': 'application/json' },
      })
      .pipe(catchError(this.formatErrors));
  }

  delete(path): Observable<any> {
    return this.http.delete(`${this.base_url}${path}?api_key=${this.getApiKey()}`).pipe(catchError(this.formatErrors));
  }
}



// WEBPACK FOOTER //
// ./src/app/app.service.ts